import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faXmark } from '@fortawesome/free-solid-svg-icons';
import { TableFilterState } from '../../hooks/useTableFilters';
import './TableHeader.css';

interface SortOption {
    label: string;
    value: string;
}

interface TableHeaderProps {
    searchValue: string;
    onSearchChange: (value: string) => void;
    searchPlaceholder?: string;
    sortValue: string;
    onSortChange: (value: string) => void;
    sortOptions: SortOption[];
    onFilterClick: () => void;
    onClearFilters: () => void;
    hasActiveFilters: boolean;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
    searchValue,
    onSearchChange,
    searchPlaceholder = 'Search...',
    sortValue,
    onSortChange,
    sortOptions,
    onFilterClick,
    onClearFilters,
    hasActiveFilters,
}) => {
    const hasSortOptions = sortOptions.length > 0;
    const hasFilterOptions = true; // Show filter button for all tables that have the filter functionality

    return (
        <div className="table-header-controls">
            <div className="table-header-left">
                <input
                    type="text"
                    className="table-search-input"
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={e => onSearchChange(e.target.value)}
                />
            </div>

            <div className="table-header-right">
                {hasSortOptions && (
                    <select
                        className="table-sort-select"
                        value={sortValue}
                        onChange={e => onSortChange(e.target.value)}
                    >
                        {sortOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                )}

                {hasFilterOptions && (
                    <>
                        <button
                            className={`table-filter-button ${hasActiveFilters ? 'active' : ''}`}
                            onClick={onFilterClick}
                            title={hasActiveFilters ? 'Active filters' : 'Open filters'}
                        >
                            <FontAwesomeIcon icon={faFilter} />
                            {hasActiveFilters && <span className="filter-badge">!</span>}
                        </button>

                        {hasActiveFilters && (
                            <button
                                className="table-clear-button"
                                onClick={onClearFilters}
                                title="Clear all filters"
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
